import { jsx as _jsx } from "react/jsx-runtime";
import usePersonCounterSelect from "../../hooks/usePersonCounterSelect.js";
import * as S from "./styled.js";
const PersonCounterSelect = (props)=>{
    const { value , options , columns =2  } = props;
    const { handleOnChange  } = usePersonCounterSelect(props);
    return /*#__PURE__*/ _jsx(S.PersonCounterSelectWrapper, {
        "data-testid": "PersonCounterSelect",
        $columns: columns,
        className: "person-counter-select",
        children: /*#__PURE__*/ _jsx(S.AgeSelect, {
            value: value,
            options: options,
            placeholder: "",
            onChange: handleOnChange
        })
    });
};
export default PersonCounterSelect;

//# sourceMappingURL=index.js.map